import React, { useContext, useEffect } from "react"

// Comps
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import AdvancedSearch from "./components/AdvancedSearch"
import PageHeader from "../../components/PageHeader"
import useLabels from "../../hooks/useLabels"

import { UserContext } from "../../context/userContext"

export default function MyParticipants() {
  const [loadingLabels, labels] = useLabels(["intake_session"])

  const userCtx = useContext(UserContext)

  useEffect(() => {
    userCtx.clearParticipant()
  }, [])

  if (loadingLabels) return null

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar searchType="all_participants" />
      </div>
      <div className="main-content">
        <PageHeader
          title="All Participants"
          actions={[
            {
              to: "/form/intake_session/1",
              label: `New ${labels.intake_session}`,
            },
          ]}
        />
        <AdvancedSearch searchType="all_participants" />
      </div>
    </div>
  )
}
